export default __webpack_public_path__ + "static/logo_full-aeabcb1f309f4193efc7a429b700c308.png";